// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RecaptchaContext$PorterinFeature from "./RecaptchaContext.mjs";

var provider = RecaptchaContext$PorterinFeature.context.Provider;

function RecaptchaProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
              value: value,
              children: children
            });
}

var make = RecaptchaProvider;

export {
  provider ,
  make ,
}
/* provider Not a pure module */
